export default __webpack_public_path__ + "static/media/aircnc-screenshot.c5978910.png";